(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trc-before-after-slider"] && !Shopify.designMode) return;
  try {
    
class BeforeAfterSlider {
  constructor(container) {
    this.container = container;
    this.slider = container.querySelector('[data-before-after-slider]');
    this.handle = container.querySelector('[data-slider-handle]');
    this.afterImage = container.querySelector('[data-after-image]');
    this.isDragging = false;

    if (!this.slider || !this.handle || !this.afterImage) {
      console.error('Before After Slider: Required elements not found');
      return;
    }

    this.init();
  }

  init() {
    // Set initial position from the handle's inline style
    const initialLeft = parseFloat(this.handle.style.left) || 50;
    this.updatePosition(initialLeft);

    // Mouse events
    this.handle.addEventListener('mousedown', this.handleMouseDown.bind(this));
    document.addEventListener('mousemove', this.handleMouseMove.bind(this));
    document.addEventListener('mouseup', this.handleMouseUp.bind(this));

    // Touch events
    this.handle.addEventListener('touchstart', this.handleTouchStart.bind(this), { passive: true });
    document.addEventListener('touchmove', this.handleTouchMove.bind(this), { passive: false });
    document.addEventListener('touchend', this.handleTouchEnd.bind(this));

    // Prevent context menu on handle
    this.handle.addEventListener('contextmenu', (e) => e.preventDefault());

    // Handle window resize
    this.handleResize = this.debounce(() => {
      if (!this.isDragging) {
        const currentLeft = parseFloat(this.handle.style.left) || 50;
        this.updatePosition(currentLeft);
      }
    }, 250);
    window.addEventListener('resize', this.handleResize);
  }

  handleMouseDown(e) {
    e.preventDefault();
    this.isDragging = true;
    this.handle.style.cursor = 'grabbing';
    document.body.style.cursor = 'ew-resize';
  }

  handleMouseMove(e) {
    if (!this.isDragging) return;
    e.preventDefault();
    this.updateSliderPosition(e.clientX);
  }

  handleMouseUp() {
    if (!this.isDragging) return;
    this.isDragging = false;
    this.handle.style.cursor = 'ew-resize';
    document.body.style.cursor = '';
  }

  handleTouchStart(e) {
    this.isDragging = true;
  }

  handleTouchMove(e) {
    if (!this.isDragging) return;
    e.preventDefault();
    const touch = e.touches[0];
    this.updateSliderPosition(touch.clientX);
  }

  handleTouchEnd() {
    this.isDragging = false;
  }

  updateSliderPosition(clientX) {
    const rect = this.slider.getBoundingClientRect();
    let position = ((clientX - rect.left) / rect.width) * 100;

    // Clamp between 0 and 100
    position = Math.max(0, Math.min(100, position));

    this.updatePosition(position);
  }

  updatePosition(percentage) {
    // Update handle position
    this.handle.style.left = `${percentage}%`;

    // Update after image clip-path
    // Invert the percentage for clip-path (0% right means show all, 100% right means show none)
    const clipPosition = 100 - percentage;
    this.afterImage.style.clipPath = `inset(0 ${clipPosition}% 0 0)`;
  }

  debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  destroy() {
    document.removeEventListener('mousemove', this.handleMouseMove);
    document.removeEventListener('mouseup', this.handleMouseUp);
    document.removeEventListener('touchmove', this.handleTouchMove);
    document.removeEventListener('touchend', this.handleTouchEnd);
    window.removeEventListener('resize', this.handleResize);
  }
}

// Initialize all before-after sliders on the page
function initBeforeAfterSliders() {
  const sliders = document.querySelectorAll('[data-testid="before-after-slider"]');
  sliders.forEach(slider => {
    if (!slider.hasAttribute('data-initialized')) {
      new BeforeAfterSlider(slider);
      slider.setAttribute('data-initialized', 'true');
    }
  });
}

// Initialize on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initBeforeAfterSliders);
} else {
  initBeforeAfterSliders();
}

// Re-initialize when sections are loaded/reloaded in the theme editor
document.addEventListener('shopify:section:load', (event) => {
  const slider = event.target.querySelector('[data-testid="before-after-slider"]');
  if (slider && !slider.hasAttribute('data-initialized')) {
    new BeforeAfterSlider(slider);
    slider.setAttribute('data-initialized', 'true');
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trc-images-carousel"] && !Shopify.designMode) return;
  try {
    
class TrcImagesCarousel {
  constructor(container) {
    this.container = container;
    this.wrapper = container.querySelector('[data-trc-carousel]');
    this.prevBtn = container.querySelector('[data-trc-prev]');
    this.nextBtn = container.querySelector('[data-trc-next]');

    this.currentIndex = 0;
    this.items = Array.from(this.container.querySelectorAll('.trc-image-item'));
    this.itemCount = this.items.length;

    this.init();
  }

  init() {
    if (!this.wrapper || this.itemCount <= 1) return;

    this.prevBtn?.addEventListener('click', () => this.prev());
    this.nextBtn?.addEventListener('click', () => this.next());

    // Touch support
    let startX = 0;
    let currentX = 0;
    let isDragging = false;

    this.wrapper.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
      isDragging = true;
    }, { passive: true });

    this.wrapper.addEventListener('touchmove', (e) => {
      if (!isDragging) return;
      currentX = e.touches[0].clientX;
    }, { passive: true });

    this.wrapper.addEventListener('touchend', () => {
      if (!isDragging) return;
      isDragging = false;

      const diff = startX - currentX;
      if (Math.abs(diff) > 50) {
        if (diff > 0) {
          this.next();
        } else {
          this.prev();
        }
      }
    });

    this.updateView();
  }

  prev() {
    this.currentIndex = (this.currentIndex - 1 + this.itemCount) % this.itemCount;
    this.updateView();
  }

  next() {
    this.currentIndex = (this.currentIndex + 1) % this.itemCount;
    this.updateView();
  }

  updateView() {
    if (!this.wrapper) return;

    const itemWidth = this.items[0].offsetWidth;
    const gap = parseInt(getComputedStyle(this.wrapper).gap) || 16;
    const scrollPosition = this.currentIndex * (itemWidth + gap);

    // Use scrollTo instead of transform for better reliability
    this.wrapper.scrollTo({
      left: scrollPosition,
      behavior: 'smooth'
    });

    // Update button states
    if (this.prevBtn) {
      this.prevBtn.disabled = this.currentIndex === 0;
    }
    if (this.nextBtn) {
      this.nextBtn.disabled = this.currentIndex === this.itemCount - 1;
    }
  }
}

// Initialize all carousels
function initTrcImagesCarousels() {
  const carousels = document.querySelectorAll('[data-testid="trc-images-carousel"]');
  carousels.forEach(carousel => {
    if (!carousel.hasAttribute('data-trc-initialized')) {
      new TrcImagesCarousel(carousel);
      carousel.setAttribute('data-trc-initialized', 'true');
    }
  });
}

// Initialize on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initTrcImagesCarousels);
} else {
  initTrcImagesCarousels();
}

// Re-initialize when sections are loaded in theme editor
document.addEventListener('shopify:section:load', (event) => {
  const carousel = event.target.querySelector('[data-testid="trc-images-carousel"]');
  if (carousel && !carousel.hasAttribute('data-trc-initialized')) {
    new TrcImagesCarousel(carousel);
    carousel.setAttribute('data-trc-initialized', 'true');
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trc-reels-carousel"] && !Shopify.designMode) return;
  try {
    
class TrcReelsCarousel {
  constructor(container) {
    this.container = container;
    this.wrapper = container.querySelector('[data-trc-carousel]');
    this.prevBtn = container.querySelector('[data-trc-prev]');
    this.nextBtn = container.querySelector('[data-trc-next]');

    this.currentIndex = 0;
    this.items = Array.from(this.container.querySelectorAll('.trc-reel-item'));
    this.itemCount = this.items.length;

    this.init();
    this.initVideoControls();
    this.initIntersectionObserver();
  }

  init() {
    if (!this.wrapper || this.itemCount <= 1) return;

    this.prevBtn?.addEventListener('click', () => this.prev());
    this.nextBtn?.addEventListener('click', () => this.next());

    // Touch support
    let startX = 0;
    let currentX = 0;
    let isDragging = false;

    this.wrapper.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
      isDragging = true;
    }, { passive: true });

    this.wrapper.addEventListener('touchmove', (e) => {
      if (!isDragging) return;
      currentX = e.touches[0].clientX;
    }, { passive: true });

    this.wrapper.addEventListener('touchend', () => {
      if (!isDragging) return;
      isDragging = false;

      const diff = startX - currentX;
      if (Math.abs(diff) > 50) {
        if (diff > 0) {
          this.next();
        } else {
          this.prev();
        }
      }
    });

    this.updateView();
  }

  initVideoControls() {
    this.items.forEach(item => {
      const video = item.querySelector('video');
      const toggleBtn = item.querySelector('[data-video-toggle]');
      const playIcon = toggleBtn?.querySelector('.trc-play-icon');
      const pauseIcon = toggleBtn?.querySelector('.trc-pause-icon');

      if (!video || !toggleBtn) return;

      // Update button state based on video state
      const updateToggleButton = () => {
        if (video.paused) {
          playIcon.style.display = 'block';
          pauseIcon.style.display = 'none';
        } else {
          playIcon.style.display = 'none';
          pauseIcon.style.display = 'block';
        }
      };

      // Toggle play/pause
      toggleBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();

        if (video.paused) {
          video.play();
        } else {
          video.pause();
        }
        updateToggleButton();
      });

      // Click on video to toggle
      video.addEventListener('click', (e) => {
        if (!item.querySelector('.trc-reel-link')) {
          e.preventDefault();
          if (video.paused) {
            video.play();
          } else {
            video.pause();
          }
          updateToggleButton();
        }
      });

      // Update button when video state changes
      video.addEventListener('play', updateToggleButton);
      video.addEventListener('pause', updateToggleButton);

      // Initial state
      updateToggleButton();
    });
  }

  initIntersectionObserver() {
    // Pause videos when they're not visible
    const observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0.5
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        const video = entry.target.querySelector('video');
        if (!video) return;

        if (entry.isIntersecting) {
          // Video is visible, play it
          video.play().catch(() => {
            // Autoplay might be blocked, that's okay
          });
        } else {
          // Video is not visible, pause it
          video.pause();
        }
      });
    }, observerOptions);

    this.items.forEach(item => {
      observer.observe(item);
    });
  }

  prev() {
    this.currentIndex = (this.currentIndex - 1 + this.itemCount) % this.itemCount;
    this.updateView();
  }

  next() {
    this.currentIndex = (this.currentIndex + 1) % this.itemCount;
    this.updateView();
  }

  updateView() {
    if (!this.wrapper) return;

    const itemWidth = this.items[0].offsetWidth;
    const gap = parseInt(getComputedStyle(this.wrapper).gap) || 16;
    const scrollPosition = this.currentIndex * (itemWidth + gap);

    // Use scrollTo instead of transform for better reliability
    this.wrapper.scrollTo({
      left: scrollPosition,
      behavior: 'smooth'
    });

    // Update button states
    if (this.prevBtn) {
      this.prevBtn.disabled = this.currentIndex === 0;
    }
    if (this.nextBtn) {
      this.nextBtn.disabled = this.currentIndex === this.itemCount - 1;
    }
  }
}

// Initialize all carousels
function initTrcReelsCarousels() {
  const carousels = document.querySelectorAll('[data-testid="trc-reels-carousel"]');
  carousels.forEach(carousel => {
    if (!carousel.hasAttribute('data-trc-initialized')) {
      new TrcReelsCarousel(carousel);
      carousel.setAttribute('data-trc-initialized', 'true');
    }
  });
}

// Initialize on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initTrcReelsCarousels);
} else {
  initTrcReelsCarousels();
}

// Re-initialize when sections are loaded in theme editor
document.addEventListener('shopify:section:load', (event) => {
  const carousel = event.target.querySelector('[data-testid="trc-reels-carousel"]');
  if (carousel && !carousel.hasAttribute('data-trc-initialized')) {
    new TrcReelsCarousel(carousel);
    carousel.setAttribute('data-trc-initialized', 'true');
  }
});

  } catch(e) { console.error(e); }
})();
})();
